export enum OnboardingTabStatuses {
  notSubmitted = "NotSubmitted",
  inReview = "InReview",
  approved = "Approved",
  rejected = "Rejected",
}
